module.exports = __webpack_public_path__ + "static/media/OrderReceiptIcon.3f88a468.svg";